// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Важно: Для использования шрифтов 'Orbitron' и 'Share Tech Mono'
  их необходимо импортировать. Рекомендуется добавить эти строки
  в ваш основной CSS-файл (например, src/index.css) или
  в <head> вашего public/index.html.
  Пример для CSS:
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap');
*/

.footer-futuristic {
  /* Основной фон и текст */
  background-color: #1A002B; /* Очень темный фиолетовый */
  color: #E0BBE4; /* Светлый контрастный текст с фиолетовым оттенком */
  padding: 30px 50px; /* Отступы внутри подвала */

  /* Светящаяся верхняя граница и тень */
  border-top: 2px solid rgba(175, 93, 255, 0.4); /* Полупрозрачная светящаяся граница */
  box-shadow: 0 -5px 20px rgba(175, 93, 255, 0.2); /* Мягкое свечение вверх */

  /* Шрифты и выравнивание */
  font-family: 'Orbitron', sans-serif; /* Футуристический шрифт для заголовков */
  text-align: center;

  /* Позиционирование для декораций */
  position: relative;
  overflow: hidden; /* Скрываем элементы, выходящие за границы */

  /* Flexbox для центрирования содержимого */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px; /* Промежуток между элементами внутри футера */
}

.footer-content {
  /* Контейнер для названия проекта и ссылки */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px; /* Промежуток между названием и ссылкой */
  z-index: 1; /* Убедимся, что контент поверх декораций */
}

.project-name {
  margin: 0; /* Убираем стандартные отступы */
  font-size: 1.6em;
  font-weight: 700;
  letter-spacing: 2px; /* Расстояние между буквами */

  /* Градиент для текста с эффектом свечения */
  background: linear-gradient(90deg, #A75DFF, #CCEEFF, #A75DFF); /* Фиолетово-голубой градиент */
  -webkit-background-clip: text; /* Обрезает фон по форме текста */
  -webkit-text-fill-color: transparent; /* Делает текст прозрачным, чтобы был виден фон */
  background-clip: text; /* Стандартное свойство */
  color: transparent; /* Fallback для старых браузеров */
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.7); /* Дополнительное свечение */
}

.github-link {
  color: #A75DFF; /* Яркий фиолетовый для ссылки */
  text-decoration: none; /* Убираем подчеркивание */
  font-size: 1em;
  font-family: 'Share Tech Mono', monospace; /* Моноширинный шрифт для кода/ссылок */

  /* Стилизация кнопки/ссылки */
  padding: 8px 15px;
  border: 1px solid #A75DFF;
  border-radius: 5px;
  background-color: rgba(167, 93, 255, 0.1); /* Полупрозрачный фон */

  /* Эффекты наведения */
  transition: color 0.3s ease, text-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
  text-shadow: 0 0 8px rgba(167, 93, 255, 0.6); /* Свечение ссылки */
}

.github-link:hover {
  color: #CCEEFF; /* Более светлый цвет на наведении */
  text-shadow: 0 0 15px rgba(204, 238, 255, 1); /* Сильнее свечение */
  background-color: rgba(167, 93, 255, 0.2); /* Немного темнее фон */
  transform: translateY(-2px); /* Небольшой подъем */
  border-color: #CCEEFF; /* Изменение цвета рамки */
}

/* Декоративные линии */
.footer-decorations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Игнорировать события мыши */
  z-index: 0; /* Декорации под контентом */
}

.deco-line {
  position: absolute;
  height: 1px; /* Толщина линии */
  /* Градиент для эффекта свечения и затухания */
  background: linear-gradient(90deg, rgba(175, 93, 255, 0) 0%, rgba(175, 93, 255, 0.5) 50%, rgba(175, 93, 255, 0) 100%);
  width: 80%; /* Ширина линии */
  opacity: 0.3; /* Начальная прозрачность */
}

.line-left {
  top: 15%; /* Позиция сверху */
  left: -20%; /* Начинается за пределами экрана */
  transform: rotate(-5deg); /* Небольшой наклон */
  animation: slideInLeft 5s ease-out infinite alternate; /* Анимация движения */
}

.line-right {
  bottom: 15%; /* Позиция снизу */
  right: -20%; /* Начинается за пределами экрана */
  transform: rotate(5deg); /* Небольшой наклон */
  animation: slideInRight 5s ease-out infinite alternate; /* Анимация движения */
}

/* Ключевые кадры для анимации линий */
@keyframes slideInLeft {
  0% { left: -20%; opacity: 0.3; }
  50% { left: 10%; opacity: 0.6; } /* Доходит до 10% от края и становится ярче */
  100% { left: -20%; opacity: 0.3; }
}

@keyframes slideInRight {
  0% { right: -20%; opacity: 0.3; }
  50% { right: 10%; opacity: 0.6; } /* Доходит до 10% от края и становится ярче */
  100% { right: -20%; opacity: 0.3; }
}

/* Медиа-запросы для адаптивности */
@media (max-width: 768px) {
  .footer-futuristic {
    padding: 20px 25px; /* Уменьшаем отступы на мобильных */
  }

  .project-name {
    font-size: 1.3em;
    letter-spacing: 1px;
  }

  .github-link {
    font-size: 0.9em;
    padding: 6px 12px;
  }

  .deco-line {
    width: 100%; /* Линии могут быть шире на маленьких экранах */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/style/Footer.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;EACE,yBAAyB;EACzB,yBAAyB,EAAE,4BAA4B;EACvD,cAAc,EAAE,oDAAoD;EACpE,kBAAkB,EAAE,2BAA2B;;EAE/C,sCAAsC;EACtC,6CAA6C,EAAE,sCAAsC;EACrF,+CAA+C,EAAE,0BAA0B;;EAE3E,0BAA0B;EAC1B,mCAAmC,EAAE,yCAAyC;EAC9E,kBAAkB;;EAElB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB,EAAE,4CAA4C;;EAE9D,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,EAAE,8CAA8C;AAC3D;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAE,yCAAyC;EACpD,UAAU,EAAE,2CAA2C;AACzD;;AAEA;EACE,SAAS,EAAE,gCAAgC;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE,6BAA6B;;EAElD,4CAA4C;EAC5C,6DAA6D,EAAE,+BAA+B;EAC9F,6BAA6B,EAAE,iCAAiC;EAChE,oCAAoC,EAAE,iDAAiD;EACvF,qBAAqB,EAAE,yBAAyB;EAChD,kBAAkB,EAAE,kCAAkC;EACtD,8CAA8C,EAAE,4BAA4B;AAC9E;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,qBAAqB,EAAE,0BAA0B;EACjD,cAAc;EACd,yCAAyC,EAAE,uCAAuC;;EAElF,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC,EAAE,uBAAuB;;EAElE,sBAAsB;EACtB,+FAA+F;EAC/F,4CAA4C,EAAE,oBAAoB;AACpE;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,4CAA4C,EAAE,qBAAqB;EACnE,yCAAyC,EAAE,uBAAuB;EAClE,2BAA2B,EAAE,qBAAqB;EAClD,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,8BAA8B;EACpD,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,kBAAkB;EAC/B,8CAA8C;EAC9C,qHAAqH;EACrH,UAAU,EAAE,iBAAiB;EAC7B,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,QAAQ,EAAE,mBAAmB;EAC7B,UAAU,EAAE,mCAAmC;EAC/C,wBAAwB,EAAE,qBAAqB;EAC/C,qDAAqD,EAAE,sBAAsB;AAC/E;;AAEA;EACE,WAAW,EAAE,kBAAkB;EAC/B,WAAW,EAAE,mCAAmC;EAChD,uBAAuB,EAAE,qBAAqB;EAC9C,sDAAsD,EAAE,sBAAsB;AAChF;;AAEA,sCAAsC;AACtC;EACE,KAAK,UAAU,EAAE,YAAY,EAAE;EAC/B,MAAM,SAAS,EAAE,YAAY,EAAE,EAAE,6CAA6C;EAC9E,OAAO,UAAU,EAAE,YAAY,EAAE;AACnC;;AAEA;EACE,KAAK,WAAW,EAAE,YAAY,EAAE;EAChC,MAAM,UAAU,EAAE,YAAY,EAAE,EAAE,6CAA6C;EAC/E,OAAO,WAAW,EAAE,YAAY,EAAE;AACpC;;AAEA,mCAAmC;AACnC;EACE;IACE,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW,EAAE,+CAA+C;EAC9D;AACF","sourcesContent":["/*\n  Важно: Для использования шрифтов 'Orbitron' и 'Share Tech Mono'\n  их необходимо импортировать. Рекомендуется добавить эти строки\n  в ваш основной CSS-файл (например, src/index.css) или\n  в <head> вашего public/index.html.\n  Пример для CSS:\n  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&family=Share+Tech+Mono&display=swap');\n*/\n\n.footer-futuristic {\n  /* Основной фон и текст */\n  background-color: #1A002B; /* Очень темный фиолетовый */\n  color: #E0BBE4; /* Светлый контрастный текст с фиолетовым оттенком */\n  padding: 30px 50px; /* Отступы внутри подвала */\n\n  /* Светящаяся верхняя граница и тень */\n  border-top: 2px solid rgba(175, 93, 255, 0.4); /* Полупрозрачная светящаяся граница */\n  box-shadow: 0 -5px 20px rgba(175, 93, 255, 0.2); /* Мягкое свечение вверх */\n\n  /* Шрифты и выравнивание */\n  font-family: 'Orbitron', sans-serif; /* Футуристический шрифт для заголовков */\n  text-align: center;\n\n  /* Позиционирование для декораций */\n  position: relative;\n  overflow: hidden; /* Скрываем элементы, выходящие за границы */\n\n  /* Flexbox для центрирования содержимого */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px; /* Промежуток между элементами внутри футера */\n}\n\n.footer-content {\n  /* Контейнер для названия проекта и ссылки */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px; /* Промежуток между названием и ссылкой */\n  z-index: 1; /* Убедимся, что контент поверх декораций */\n}\n\n.project-name {\n  margin: 0; /* Убираем стандартные отступы */\n  font-size: 1.6em;\n  font-weight: 700;\n  letter-spacing: 2px; /* Расстояние между буквами */\n\n  /* Градиент для текста с эффектом свечения */\n  background: linear-gradient(90deg, #A75DFF, #CCEEFF, #A75DFF); /* Фиолетово-голубой градиент */\n  -webkit-background-clip: text; /* Обрезает фон по форме текста */\n  -webkit-text-fill-color: transparent; /* Делает текст прозрачным, чтобы был виден фон */\n  background-clip: text; /* Стандартное свойство */\n  color: transparent; /* Fallback для старых браузеров */\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.7); /* Дополнительное свечение */\n}\n\n.github-link {\n  color: #A75DFF; /* Яркий фиолетовый для ссылки */\n  text-decoration: none; /* Убираем подчеркивание */\n  font-size: 1em;\n  font-family: 'Share Tech Mono', monospace; /* Моноширинный шрифт для кода/ссылок */\n\n  /* Стилизация кнопки/ссылки */\n  padding: 8px 15px;\n  border: 1px solid #A75DFF;\n  border-radius: 5px;\n  background-color: rgba(167, 93, 255, 0.1); /* Полупрозрачный фон */\n\n  /* Эффекты наведения */\n  transition: color 0.3s ease, text-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;\n  text-shadow: 0 0 8px rgba(167, 93, 255, 0.6); /* Свечение ссылки */\n}\n\n.github-link:hover {\n  color: #CCEEFF; /* Более светлый цвет на наведении */\n  text-shadow: 0 0 15px rgba(204, 238, 255, 1); /* Сильнее свечение */\n  background-color: rgba(167, 93, 255, 0.2); /* Немного темнее фон */\n  transform: translateY(-2px); /* Небольшой подъем */\n  border-color: #CCEEFF; /* Изменение цвета рамки */\n}\n\n/* Декоративные линии */\n.footer-decorations {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Игнорировать события мыши */\n  z-index: 0; /* Декорации под контентом */\n}\n\n.deco-line {\n  position: absolute;\n  height: 1px; /* Толщина линии */\n  /* Градиент для эффекта свечения и затухания */\n  background: linear-gradient(90deg, rgba(175, 93, 255, 0) 0%, rgba(175, 93, 255, 0.5) 50%, rgba(175, 93, 255, 0) 100%);\n  width: 80%; /* Ширина линии */\n  opacity: 0.3; /* Начальная прозрачность */\n}\n\n.line-left {\n  top: 15%; /* Позиция сверху */\n  left: -20%; /* Начинается за пределами экрана */\n  transform: rotate(-5deg); /* Небольшой наклон */\n  animation: slideInLeft 5s ease-out infinite alternate; /* Анимация движения */\n}\n\n.line-right {\n  bottom: 15%; /* Позиция снизу */\n  right: -20%; /* Начинается за пределами экрана */\n  transform: rotate(5deg); /* Небольшой наклон */\n  animation: slideInRight 5s ease-out infinite alternate; /* Анимация движения */\n}\n\n/* Ключевые кадры для анимации линий */\n@keyframes slideInLeft {\n  0% { left: -20%; opacity: 0.3; }\n  50% { left: 10%; opacity: 0.6; } /* Доходит до 10% от края и становится ярче */\n  100% { left: -20%; opacity: 0.3; }\n}\n\n@keyframes slideInRight {\n  0% { right: -20%; opacity: 0.3; }\n  50% { right: 10%; opacity: 0.6; } /* Доходит до 10% от края и становится ярче */\n  100% { right: -20%; opacity: 0.3; }\n}\n\n/* Медиа-запросы для адаптивности */\n@media (max-width: 768px) {\n  .footer-futuristic {\n    padding: 20px 25px; /* Уменьшаем отступы на мобильных */\n  }\n\n  .project-name {\n    font-size: 1.3em;\n    letter-spacing: 1px;\n  }\n\n  .github-link {\n    font-size: 0.9em;\n    padding: 6px 12px;\n  }\n\n  .deco-line {\n    width: 100%; /* Линии могут быть шире на маленьких экранах */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
